<div class="customers-container">
    <!-- Header Section -->
    <div class="customers-header">
        <div class="header-left">
            <img src="./assets/images/icons/dashboard/user_card_red.png" alt="user card Icon" class="file-icon">
            <span class="header-title">
                <span class="title-text">Clients / <strong class="username">{{ isEditMode ? "Modifier le client" : "Création d'un client" }}</strong></span>
            </span>
        </div>

        <div class="header-right">
            <button class="back-btn" (click)="goToList()">
                <img src="assets/images/icons/back-arrow.png" alt="back" class="back-icon">
                <span>Retour à la liste</span>
            </button>
        </div>
    </div>

    <div class="customer-form-container">
        <!-- Success Message -->
        <div *ngIf="showSuccess" class="success-message">
            <div class="success-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#4CB86E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                    <polyline points="22 4 12 14.01 9 11.01"></polyline>
                </svg>
            </div>
            <p>{{ successMessage }}</p>
            <div class="success-actions">
                <button *ngIf="!isEditMode" type="button" class="btn btn-primary" (click)="createAnother()">
                    Créer un autre client
                </button>
                <button type="button" class="btn btn-cancel" (click)="goToList()">
                    Retour à la liste
                </button>
            </div>
        </div>

        <!-- Loading State -->
        <div *ngIf="isLoading" class="loading-state">
            <div class="loading-spinner"></div>
            <p>Chargement des informations du client...</p>
        </div>

        <!-- Main Form -->
        <form *ngIf="!showSuccess && !isLoading" [formGroup]="customerForm" (ngSubmit)="onSubmit()" class="customer-form">
            <!-- Profile Image Upload -->
            <div class="form-section">
                <h3 class="section-title">Photo de profil</h3>
                <div class="profile-upload-area" [class.has-file]="selectedFile || previewUrl">
                    <div class="profile-image-container" (click)="fileInput.click()">
                        <div *ngIf="previewUrl" class="image-preview">
                            <img [src]="previewUrl" alt="Profile Preview" class="preview-image">
                        </div>
                        <div *ngIf="!previewUrl" class="upload-placeholder" (click)="onFileSelected($event)">
                            <img src="assets/images/icons/upload.png" alt="Upload" class="upload-icon">
                            <p class="upload-text">Ajouter une photo</p>
                            <p class="upload-hint">JPG, PNG (max 5MB)</p>
                        </div>
                        <input #fileInput type="file" accept="image/*" (change)="onFileSelected($event)" class="file-input" hidden>
                    </div>
                    <div class="profile-upload-actions">
                        <button *ngIf="previewUrl" type="button" class="btn btn-sm" (click)="removeFile()">
                            Supprimer
                        </button>
                    </div>
                </div>
            </div>

            <!-- Account Information Section -->
            <!--<div class="form-section mb-0">
                <div class="form-row">
                    <div class="form-group" *ngIf="!isEditMode">
                        <label for="password">Mot de passe *</label>
                        <input type="password" id="password" formControlName="password" class="form-control" [class.is-invalid]="password?.invalid && password?.touched" placeholder="Entrez le mot de passe">
                        <div *ngIf="password?.invalid && password?.touched" class="form-error">
                            <span *ngIf="password?.errors?.['required']">Le mot de passe est obligatoire</span>
                            <span *ngIf="password?.errors?.['minlength']">Le mot de passe doit contenir au moins 6 caractères</span>
                        </div>
                    </div>
                </div>
            </div>-->

            <!-- Personal Information Section -->
            <div class="form-section mb-0">
                <h3 class="section-title">Informations personnelles</h3>
                <div class="form-row">
                    <div class="form-group">
                        <label for="firstName">Prénom *</label>
                        <input type="text" id="firstName" formControlName="firstName" class="form-control" [class.is-invalid]="firstName?.invalid && firstName?.touched" placeholder="Entrez le prénom">
                        <div *ngIf="firstName?.invalid && firstName?.touched" class="form-error">
                            <span *ngIf="firstName?.errors?.['required']">Le prénom est obligatoire</span>
                            <span *ngIf="firstName?.errors?.['minlength']">Le prénom doit contenir au moins 2 caractères</span>
                            <span *ngIf="firstName?.errors?.['maxlength']">Le prénom ne doit pas dépasser 100 caractères</span>
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="lastName">Nom *</label>
                        <input type="text" id="lastName" formControlName="lastName" class="form-control" [class.is-invalid]="lastName?.invalid && lastName?.touched" placeholder="Entrez le nom">
                        <div *ngIf="lastName?.invalid && lastName?.touched" class="form-error">
                            <span *ngIf="lastName?.errors?.['required']">Le nom est obligatoire</span>
                            <span *ngIf="lastName?.errors?.['minlength']">Le nom doit contenir au moins 2 caractères</span>
                            <span *ngIf="lastName?.errors?.['maxlength']">Le nom ne doit pas dépasser 100 caractères</span>
                        </div>
                    </div>
                </div>

                <div class="form-row">
                    <div class="form-group" *ngIf="!isEditMode">
                        <label for="email">Email *</label>
                        <input type="email" id="email" formControlName="email" class="form-control" [class.is-invalid]="email?.invalid && email?.touched" placeholder="Ex: client@example.com">
                        <div *ngIf="email?.invalid && email?.touched" class="form-error">
                            <span *ngIf="email?.errors?.['required']">L'email est obligatoire</span>
                            <span *ngIf="email?.errors?.['email']">Format d'email invalide</span>
                            <span *ngIf="email?.errors?.['maxlength']">L'email ne doit pas dépasser 255 caractères</span>
                        </div>
                        <div *ngIf="emailAlreadyExists" class="form-error">
                            <span>Cet email est déjà utilisé par un autre client</span>
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="phoneNumber">Téléphone *</label>
                        <input type="tel" id="phoneNumber" formControlName="phoneNumber" class="form-control" [class.is-invalid]="phoneNumber?.invalid && phoneNumber?.touched" placeholder="Ex: +33 1 23 45 67 89">
                        <div *ngIf="phoneNumber?.invalid && phoneNumber?.touched" class="form-error">
                            <span *ngIf="phoneNumber?.errors?.['required']">Le téléphone est obligatoire</span>
                            <span *ngIf="phoneNumber?.errors?.['pattern']">Format de téléphone invalide</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Company Information Section -->
            <div class="form-section mb-0">
                <h3 class="section-title">Informations de l'entreprise</h3>
                <div class="form-row">
                    <div class="form-group">
                        <label for="companyName">Nom de l'entreprise</label>
                        <input type="text" id="companyName" formControlName="companyName" class="form-control" [class.is-invalid]="companyName?.invalid && companyName?.touched" placeholder="Entrez le nom de l'entreprise">
                        <div *ngIf="companyName?.invalid && companyName?.touched" class="form-error">
                            <span *ngIf="companyName?.errors?.['maxlength']">Le nom de l'entreprise ne doit pas dépasser 200 caractères</span>
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="vatNumber">Numéro de TVA</label>
                        <input type="text" id="vatNumber" formControlName="vatNumber" class="form-control" [class.is-invalid]="vatNumber?.invalid && vatNumber?.touched" placeholder="Entrez le numéro de TVA">
                        <div *ngIf="vatNumber?.invalid && vatNumber?.touched" class="form-error">
                            <span *ngIf="vatNumber?.errors?.['maxlength']">Le numéro de TVA ne doit pas dépasser 50 caractères</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Address Information Section -->
            <div class="form-section mb-0" [formGroup]="addressForm">
                <h3 class="section-title">Adresse</h3>
                <div class="form-row">
                    <div class="form-group">
                        <label for="streetNumber">Adresse *</label>
                        <input type="text" id="streetNumber" formControlName="streetNumber" class="form-control" [class.is-invalid]="streetNumber?.invalid && streetNumber?.touched" placeholder="Numéro et nom de la rue">
                        <div *ngIf="streetNumber?.invalid && streetNumber?.touched" class="form-error">
                            <span *ngIf="streetNumber?.errors?.['required']">L'adresse est obligatoire</span>
                            <span *ngIf="streetNumber?.errors?.['maxlength']">L'adresse ne doit pas dépasser 200 caractères</span>
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="street">Complément d'adresse</label>
                        <input type="text" id="street" formControlName="street" class="form-control" [class.is-invalid]="street?.invalid && street?.touched" placeholder="Appartement, étage, bâtiment...">
                        <div *ngIf="street?.invalid && street?.touched" class="form-error">
                            <span *ngIf="street?.errors?.['maxlength']">L'adresse ne doit pas dépasser 200 caractères</span>
                        </div>
                    </div>
                </div>

                <div class="form-row">
                    <div class="form-group">
                        <label for="city">Ville *</label>
                        <input type="text" id="city" formControlName="city" class="form-control" [class.is-invalid]="city?.invalid && city?.touched" placeholder="Ex: Bruxelles">
                        <div *ngIf="city?.invalid && city?.touched" class="form-error">
                            <span *ngIf="city?.errors?.['required']">La ville est obligatoire</span>
                            <span *ngIf="city?.errors?.['maxlength']">La ville ne doit pas dépasser 100 caractères</span>
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="postalCode">Code postal *</label>
                        <input type="text" id="postalCode" formControlName="postalCode" class="form-control" [class.is-invalid]="postalCode?.invalid && postalCode?.touched" placeholder="Ex: 1040">
                        <div *ngIf="postalCode?.invalid && postalCode?.touched" class="form-error">
                            <span *ngIf="postalCode?.errors?.['required']">Le code postal est obligatoire</span>
                            <span *ngIf="postalCode?.errors?.['pattern']">Format de code postal invalide (4-10 chiffres)</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Form Actions -->
            <div class="form-actions">
                <button type="submit" class="btn btn-primary btn-block" [disabled]="isSubmitting || customerForm.invalid">
                    <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm me-2"></span>
                    {{ isSubmitting ? 'Enregistrement...' : (isEditMode ? 'Modifier le client' : 'Créer le client') }}
                </button>
                <button type="button" class="btn btn-cancel" (click)="goToList()">
                    Annuler
                </button>
            </div>
        </form>
    </div>
</div>